import {Component, OnInit} from '@angular/core';
import {StorageService} from "../../../services/storage.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {ProfileObject} from "../../../guest/login/login.graphql";
import {environment} from "../../../../environments/environment";
import {GET_NOTIFICATIONS, NotificationModel} from "../../../modules/settings/notifications/notifications";
import {Apollo} from "apollo-angular";
import {NotificationsComponent} from "../../../modules/settings/notifications/notifications.component";
import {SettingsService} from "../../../services/settings.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userType: string;
  user: string;
  profile: ProfileObject;
  institution: any;
  photo: any;

  activeLanguage: 'en' | 'sw'

  notificationList: NotificationModel[]
  totalUnreadNotification = 0
  page: any

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private apollo: Apollo,
    private settingsService: SettingsService,
  ) {
    this.activeLanguage = this.storageService.getItem('language') || 'en'
  }

  onToggleChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.activeLanguage = 'sw';
      this.onChangeLanguage('sw');
    } else {
      this.activeLanguage = 'en';
      this.onChangeLanguage('en');
    }
  }

  onChangeLanguage(lang: 'en' | 'sw') {
    this.storageService.setItem('language', lang)
    window.location.reload()
  }

  ngOnInit(): void {
    this.profile = this.storageService.getItem('profile');
    this.institution = this.storageService.getItem('institution');
    this.photo = environment.FILE_SERVER_URL + this.profile.profilePhoto

    this.loadNotifications()

  }

  loadNotifications() {
    this.apollo
      .query({
        query: GET_NOTIFICATIONS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            pageNumber: 1,
            itemsPerPage: 5,
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getNotifications;
        if (result?.response.status) {
          this.notificationList = result?.data
          this.totalUnreadNotification = result?.stats?.totalUnread
          this.page = result?.page
        }
      });

  }

  logout() {
    this.authService.logout();
  }

  notifications():void{
    let dialogRef = this.settingsService.openDialogModal({
      component: NotificationsComponent,
      data: {
        notifications: this.notificationList,
        page: this.page
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.totalUnreadNotification -= 1
      }
    })
  }
}
